const NS_VARIANT_LABELS: Record<number, string> = {
  1: "BLUE",
  2: "GREEN",
  3: "PINK",
  4: "PURPLE",
  5: "WHITE",
  6: "YELLOW",
  7: "RARE PINK",
};

// const NS_VARIANT_IMAGES: Record<number, string> = {
//   0: "1-blue.png",
//   1: "2-green.png",
//   2: "3-pink.png",
//   3: "4-purple.png",
//   4: "5-white.png",
//   5: "6-yellow.png",
//   6: "7-rare-pink.png",
// };

const NS_VARIANT_IMAGES: Record<number, string> = {
  1: "1-blue.png",
  2: "2-green.png",
  3: "3-pink.png",
  4: "4-purple.png",
  5: "5-white.png",
  6: "6-yellow.png",
  7: "7-rare-pink.png",
};

export const NS_COLLECTION_NAME = "223 x Nobody Sausage";
export const NS_COLLECTION_SLUG = "nobodysausage";
export const NS_CLAIM_PATH = "/claim/nobodysausage";
export const NS_REWARDS_PATH = "/rewards/nobodysausage";

export function getNobodySausageVariantLabel(tokenType: number | undefined) {
  return NS_VARIANT_LABELS[tokenType ?? -1] ?? "UNKNOWN";
}

export function getNobodySausageImageUrl(tokenType: number | undefined) {
  const file = NS_VARIANT_IMAGES[tokenType ?? -1];
  if (!file) {
    return "/images/nobodysausage/ns-landing.png";
  }
  return `/images/nobodysausage/${file}`;
}
